<div class="linked-contact" *ngIf="contact">
  <p class="linked-contact__title">{{ title }}</p>

  <div class="linked-contact__person">
    <i class="pi pi-user"></i>
    <div class="linked-contact__details">
      <p class="linked-contact__name">{{ contactName || '–' }}</p>
      <p class="linked-contact__meta" *ngIf="contact.email"><i class="pi pi-envelope"></i>{{ contact.email }}</p>
      <p class="linked-contact__meta" *ngIf="contact.mobile_no"><i class="pi pi-phone"></i>{{ contact.mobile_no | mobileFormat }}</p>
    </div>
  </div>

  <ng-container *ngIf="alternateContacts.length">
    <p class="linked-contact__subtitle">ALTERNATE CONTACTS</p>
    <div class="linked-contact__person" *ngFor="let person of alternateContacts; trackBy: trackByIndex">
      <i class="pi pi-users"></i>
      <div class="linked-contact__details">
        <p class="linked-contact__name">
          {{ person.name || '–' }}
          <span class="linked-contact__pill" *ngIf="person.label">{{ person.label }}</span>
          <span class="linked-contact__pill linked-contact__pill--current" *ngIf="isThisLead(person)">This lead</span>
        </p>
        <p class="linked-contact__meta" *ngIf="person.email"><i class="pi pi-envelope"></i>{{ person.email }}</p>
        <p class="linked-contact__meta" *ngIf="person.mobile_no"><i class="pi pi-phone"></i>{{ person.mobile_no | mobileFormat }}</p>
      </div>
    </div>
  </ng-container>

  <div class="linked-contact__prompt" *ngIf="needsAlternateEntry">
    <p class="linked-contact__prompt-text">
      <i class="pi pi-info-circle"></i>
      {{ leadName || 'This lead' }} Is Not Saved On This Contact Yet.
    </p>
    <ng-select
      class="linked-contact__label"
      [items]="labelOptions"
      [(ngModel)]="selectedLabel"
      [addTag]="addCustomLabel"
      addTagText="Add"
      [clearable]="true"
      [markFirst]="false"
      placeholder="Select Label (Optional)"
      appendTo="body"></ng-select>
    <button type="button" class="_outline-btn linked-contact__add" [disabled]="isSaving" (click)="onAddAlternate()">
      <i class="pi pi-user-plus f-12 mr-2"></i>Add As Alternate Contact
    </button>
  </div>
</div>
